// extracted by mini-css-extract-plugin
module.exports = {"chart":"circle-pie_chart_1XoYf","content":"circle-pie_content_14by7"};